import { useCallback } from 'react';
import {
  APP_PROGRAM_ID,
  DEFAULT_LANGUAGE,
  LOCAL_STORAGE_KEYS,
} from 'src/contstant/commonLabels';
import { useBusinessUnit } from 'src/store/businessUnit/useBusinessUnit';
import { useUserPreferences } from 'src/store/userPreferences/useUserPreferences';
import { useUsers } from 'src/store/users/useUsers';
import { getFromLocalStorage } from 'src/utils/localStorageUtils';
const useUserProfile = () => {
  const { currentUser, currentUserMetadata, selectUserLanguage, userSelectedLanguage } =
    useUsers();
  const { userPreferences } = useUserPreferences();
  const { businessUnitList } = useBusinessUnit();
  const getUserId = useCallback(
    () => getFromLocalStorage<string>(LOCAL_STORAGE_KEYS.MIDWAY_AUTH_USERNAME, ''),
    [],
  );
  const getUserProgramId = useCallback(() => APP_PROGRAM_ID, []);
  const getUserBusinessUnitId = useCallback(
    () => userPreferences?.profileSettings?.businessUnit || '',
    [userPreferences?.profileSettings?.businessUnit],
  );
  const getPersona = useCallback((): string => {
    const persona = currentUser?.userPermission?.roleId || '';

    return persona;
  }, [currentUser?.userPermission?.roleId]);
  const getDivisions = useCallback(
    () => currentUser?.userPermission.divisions,
    [currentUser?.userPermission.divisions],
  );
  const getUserName = useCallback(
    () => currentUserMetadata?.fullName || currentUser?.userPermission.userName!,
    [currentUserMetadata?.fullName, currentUser?.userPermission.userName],
  );
  const getUserSelectedLanguage = useCallback(
    () => userSelectedLanguage || DEFAULT_LANGUAGE,
    [userSelectedLanguage],
  );
  const getUserEmail = useCallback(
    () => currentUser?.userPermission.userId,
    [currentUser?.userPermission.userId],
  );
  const getLanguage = useCallback(() => {
    const language = userPreferences?.profileSettings?.language;
    return language && language !== null ? language : DEFAULT_LANGUAGE;
  }, [userPreferences?.profileSettings?.language]);

  const getLocations = useCallback(
    () =>
      userPreferences?.profileSettings?.businessUnitPreferences?.find(
        (item) => item.businessUnit === userPreferences?.profileSettings?.businessUnit,
      )?.locations || [],
    [userPreferences?.profileSettings],
  );

  const getUserBusinessUnitName = useCallback(
    () =>
      businessUnitList.find((bu) => bu.businessUnitId === getUserBusinessUnitId())
        ?.name ?? getUserBusinessUnitId(),
    [businessUnitList, getUserBusinessUnitId],
  );

  const getPreferLanguageList = useCallback(
    () => [DEFAULT_LANGUAGE, getLanguage()],
    [getLanguage],
  );
  return {
    getUserId,
    getUserProgramId,
    getUserBusinessUnitId,
    getPersona,
    getDivisions,
    getUserName,
    getUserEmail,
    getLanguage,
    getLocations,
    getUserBusinessUnitName,
    currentUser,
    selectUserLanguage,
    getUserSelectedLanguage,
    getPreferLanguageList,
  };
};

export default useUserProfile;
